import React from 'react';
import { Badge } from 'react-bootstrap';

const OperationsSectionHeader = ({ title, count, viewAllLink }) => (
    <div className="d-flex justify-content-between align-items-center">
        <h6 className="mb-0 d-flex align-items-center gap-2">
            {title}
            {count !== undefined && count !== null && (
                <Badge bg={count > 0 ? 'primary' : 'secondary'}>{count}</Badge>
            )}
        </h6>
        {viewAllLink}
    </div>
);

export default OperationsSectionHeader;
